<template>
    <div class="project-page-yearly-view">
        <ah-data-table
            class="project-yearly-data-table"
            tableKey="project-yearly-data-table"
            v-loading="isLoading"
            empty-text="沒有符合搜尋條件的專案"
            :columns="modifiedColumns"
            :data="datas"
            :indexStart="(currPage - 1) * pageSize + 1"
            :showRefreshButton="true"
            @row-click="onDataRowClick"
            @refresh="$emit('refresh')"
        >
            <template slot="top-right-actions">
                <slot name="top-right-actions" />
            </template>
            <template v-slot:poo="scope">
                <span class="idx">{{ scope.row.poo }}</span>
            </template>
            <template v-slot:stG_STS="scope">
                <span v-if="scope.row.stG_STS === 1" class="ah-status done" >結案</span>
                <span v-if="scope.row.stG_STS === 0" class="ah-status pending" >進行中</span>
            </template>
            <template v-slot:pjcaT_NAM="scope">
                <span class="type-tag">{{ scope.row.pjcaT_NAM }}</span>
            </template>
            <template v-slot:nam="scope">
                <div>
                    <div class="projectName">
                        <span v-if="!scope.columns.pjcaT_NAM.visible" class="type-tag">{{ scope.row.pjcaT_NAM }}</span>
                        <span class="name">{{ scope.row.nam }}</span>
                    </div>
                    <div v-if="!scope.columns.vdR_NAM.visible" class="projectClient small">{{ scope.row.vdR_NAM }}</div>
                </div>
            </template>
            <template v-slot:vdR_NAM="scope">
                <span class="projectClient">{{ scope.row.vdR_NAM }}</span>
            </template>
            <template v-slot:amt="scope">
                <Money :v="scope.row.amt" class="project-amt" :cny="scope.row.cny" />
                <div v-if="!scope.columns.cny.visible" class="cny">{{ scope.row.cny }}</div>
            </template>
            <template v-slot:timeProgress="scope">
                <ah-progress-cell-item :percentage="getTimeProgress(scope.row)">
                    <div>開始：{{ getFormatDate(scope.row.sdt) }}</div>
                    <div>結束：{{ getFormatDate(scope.row.edt) }}</div>
                </ah-progress-cell-item>
            </template>
            <template v-slot:totalAmt="scope">
                <Money :v="scope.row.invoicedAmount" round />
                <div class="other-info">{{ getTotalAmtPercentage(scope.row) }}</div>
            </template>
            <template v-slot:nonIssuedAmt="scope">
                <Money :v="scope.row.amt - scope.row.invoicedAmount" round />
                <div class="other-info">{{ getNonIssuedAmtPercentage(scope.row) }}</div>
            </template>
            <template v-for="year in yearlyInvoicedInfos" v-slot:[`year_${year}`]="scope">
                <div :key="`yearcell_${year}`">
                    <div v-if="getAmtByYear(scope.row.yearlyInvoicedInfos, year)">
                        <div>
                            <Money :v="getAmtByYear(scope.row.yearlyInvoicedInfos, year)" round />
                        </div>
                        <div v-if="getDiscountAmtByYear(scope.row.yearlyInvoicedInfos, year) > 0" style="font-size: 11px;">
                            折讓 <Money :v="getDiscountAmtByYear(scope.row.yearlyInvoicedInfos, year)" round style="font-size: 11px;"/>
                        </div>
                        <ahTip v-if="scope.row.cny !== 'TWD'">
                            <div class="other-info">
                                約當台幣：
                                <Money :v="getAmtTwdByYear(scope.row.yearlyInvoicedInfos, year)" round />
                            </div>
                        </ahTip>
                    </div>
                    <div v-else>--</div>
                </div>
            </template>
        </ah-data-table>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahProgressCellItem from '@/components/ui/ahProgressCellItem.vue';
import ahDataTable from '@/components/ui/ahDataTable.vue';

export default {
    components: {
        ahDataTable,
        ahProgressCellItem,
    },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
        getRowClass: {
            type: Function,
            default: () => {},
        },
        pjStartDate: {
            type: Array,
            default: () => [],
        },
        pageSize: {
            type: Number,
            default: 25,
        },
        currPage: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            columns: {
                index: {
                    label: '#',
                },
                poo: {
                    label: '專案編號',
                    width: 100,
                    hideByDefault: true,
                },
                customnumber: {
                    label: '自訂編號',
                    width: 100,
                    hideByDefault: true,
                },
                stG_STS: {
                    label: '專案狀態',
                    width: 80,
                },
                pjcaT_NAM: {
                    label: '專案類型',
                    width: 110,
                    hideByDefault: true,
                },
                nam: {
                    label: '專案名稱',
                    disableHide: true,
                },
                vdR_NAM: {
                    label: '客戶',
                    hideByDefault: true,
                },
                timeProgress: {
                    label: '專案時程',
                    width: 135,
                },
                amt: {
                    label: '專案總額',
                    align: 'right',
                    width: 115,
                },
                cny: {
                    label: '幣別',
                    width: 70,
                    hideByDefault: true,
                },
                totalAmt: {
                    label: '累積銷售總額',
                    width: 130,
                    align: 'right',
                },
                nonIssuedAmt: {
                    label: '專案未開金額',
                    width: 130,
                    align: 'right',
                },
            },
        };
    },
    computed: {
        modifiedColumns() {
            const newColumns = JSON.parse(JSON.stringify(this.columns));
            const tempColumns = {
                totalAmt: JSON.parse(JSON.stringify(newColumns.totalAmt)),
                nonIssuedAmt: JSON.parse(JSON.stringify(newColumns.nonIssuedAmt)),
            };
            delete newColumns.totalAmt;
            delete newColumns.nonIssuedAmt;
            this.yearlyInvoicedInfos.forEach((y) => {
                newColumns[`year_${y}`] = {
                    label: `${y} 年開發票金額`,
                    tableHeader: `${y} 年<br/>開發票金額`,
                    align: 'right',
                    width: 120,
                };
            });
            newColumns.totalAmt = tempColumns.totalAmt;
            newColumns.nonIssuedAmt = tempColumns.nonIssuedAmt;
            return newColumns;
        },
        yearlyInvoicedInfos() {
            const returnObj = [];
            const FIRST = moment(Number(_.head(this.pjStartDate))).year();
            const END = moment(Number(_.last(this.pjStartDate))).year();

            for (let i = FIRST; i <= END; i += 1) {
                returnObj.push(i);
            }
            return returnObj;
        },
    },
    methods: {
        getTimeProgress(row) {
            const start = row.sdt;
            const end = row.edt;
            const today = new Date().getTime();

            if (end === start) return 100;
            if (end < start) return 0;
            if (today < start) return 0;
            if (today >= end) return 100;

            return Math.round(((today - start) / (end - start)) * 100);
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        getFormatDate(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD');
        },
        getAmtByYear(yearlyInvoicedInfos, year) {
            return Math.round(_.find(yearlyInvoicedInfos, ['year', year])?.amt);
        },
        getDiscountAmtByYear(yearlyInvoicedInfos, year) {
            return Math.round(_.find(yearlyInvoicedInfos, ['year', year])?.discountAmt);
        },
        getAmtTwdByYear(row, year) {
            return _.find(row, ['year', year])?.amtTwd || '--';
        },
        onDataRowClick(data) {
            this.$emit('row-click', data);
        },
        getTotalAmtPercentage(row) {
            if (row.amt === 0 || row.invoicedAmount === 0) {
                return '0%';
            }
            return `${Math.round((row.invoicedAmount / row.amt) * 100)}%`;
        },
        getNonIssuedAmtPercentage(row) {
            if (row.amt === 0 || row.invoicedAmount === 0) {
                return '0%';
            }
            return `${100 - Math.round((row.invoicedAmount / row.amt) * 100)}%`;
        },
    },
};
</script>

<style lang="scss">
.project-yearly-data-table {
    .projectClient {
        color: #888;
        font-size: 10pt;
        line-height: 100%;
        margin-top: 6px;

        &.small {
            color: #aaa;
            font-size: 9pt;
        }
    }
    .project-amt {
        font-size: 10pt;
    }
    .cny {
        color: #aaa;
    }
    .money {
        font-size: 10pt;
        font-weight: 500;

        &.negative {
            color: rgb(222, 66, 66);
        }
    }
    .other-info {
        color: #aaa;
        font-size: 10pt;
    }
    // 年度開發票金額底色處理
    th[class*="head-cell-year_"] {
        background-color: #f8faff;
    }
    td[class*="body-cell-year_"] {
        background-color: #f8faff;
    }
}
</style>
